/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_CurrencyInputs */

const en_pricing_currency = /** @type {(inputs: Pricing_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

const id_pricing_currency = /** @type {(inputs: Pricing_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mata uang`)
};

/**
* | output |
* | --- |
* | "Currency" |
*
* @param {Pricing_CurrencyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_currency = /** @type {((inputs?: Pricing_CurrencyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_CurrencyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_currency(inputs)
	return en_pricing_currency(inputs)
});